module.exports = __webpack_public_path__ + "static/img/9134_phase_function_Paper_PointsHejduk_Prediction.b818748.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/9134_phase_function_Paper_PointsHejduk_Prediction.png
// module id = t2G5
// module chunks = 0